import { ModuleTree } from 'vuex';

const requireModules = require.context('./', true, /\.ts$/);

const modules = requireModules.keys().reduce((modules: ModuleTree<any>, fileName): object => {
  if (fileName === './common.ts') {
    let words = requireModules(fileName).default;
    for (let key in words) {
      modules[key] = words[key];
    }
  } else if (fileName !== './index.ts') {
    let words = requireModules(fileName).default;
    let pointSlash = /^\.\//;
    let slash = /\//g;
    let nameLength = fileName.length - 3;
    if (fileName.indexOf('/index.ts') === fileName.length - 9) {
      nameLength -= 6;
    }
    let prefix = fileName
      .substr(0, nameLength)
      .replace(pointSlash, '')
      .replace(slash, '_')
      .toUpperCase();

    for (let key in words) {
      modules[prefix + '_' + key] = words[key];
    }
  }
  return modules;
}, {});

export default modules;
